import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalCrearTrabajadorPage } from './modal-crear-trabajador.page';

const routes: Routes = [
  {
    path: '',
    component: ModalCrearTrabajadorPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalCrearTrabajadorPageRoutingModule {}
